module.exports = __webpack_public_path__ + "img/rain.3a2d7481.svg";